import { Button } from "../ui/button";
import { Dialog, DialogContent } from "../ui/dialog";
import { X } from "lucide-react";

export function ImageViewerModal({ open, onOpenChange, imageUrl, styleName }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl p-0 bg-black/95">
        <div className="relative">
          <Button 
            variant="ghost" 
            size="icon" 
            className="absolute top-2 right-2 text-white hover:bg-white/20 z-10" 
            onClick={() => onOpenChange(false)}
          >
            <X className="w-6 h-6" />
          </Button>
          <div className="p-4">
            <h3 className="text-white text-lg font-medium mb-4 text-center">{styleName}</h3>
            {imageUrl && (
              <img 
                src={imageUrl.replace('width=400', 'width=800')} 
                alt={styleName} 
                className="w-full max-h-[70vh] object-contain rounded-lg" 
              />
            )}
            <p className="text-white/70 text-sm text-center mt-4">Click outside or press X to close</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
